const state = {
  notesFromDB: {},
  itensFromXML: [],
  selectedNote: {},
  keys: [],
  totalDifalApured: 0,
};

export default state;
